// src/api/axiosInstances.js
import { data } from "autoprefixer";
import axios from "axios";
import { API_LOSS_URL, API_INSURANCE_URL, API_LMS_URL, API_COLLATERAL_URL } from "configs/AppConfig";


const commongConfig = {
  timeout: 60000,
  mode: "no-cors",
  credentials: "include",
  withCredentials: false,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": "application/json",
    Accept: "application/json",
    data: {},
  },
};

// Buat instance berbeda
export const lmsAPI = axios.create({
  baseURL: API_LMS_URL,
  ...commongConfig,
});

export const insuranceAPI = axios.create({
  baseURL: API_INSURANCE_URL,
  ...commongConfig,
});

export const lossAPI = axios.create({
  baseURL: API_LOSS_URL,
  //  baseURL: API_INSURANCE_URL,
  ...commongConfig,
});

export const collateralAPI = axios.create({
  baseURL: API_COLLATERAL_URL,
  ...commongConfig,
});
